import { createActions } from 'redux-actions';

const createAsyncActionTypes = actionTypeName => ({
  RESET: `${actionTypeName}_RESET`,
  REQUEST: `${actionTypeName}_REQUEST`,
  SUCCESS: `${actionTypeName}_SUCCESS`,
  FAILURE: `${actionTypeName}_FAILURE`,
});

const createAsyncActionTypesArray = actionTypeName => Object.values(createAsyncActionTypes(actionTypeName));


export default createActions(
  // ----- TASKS -----
  ...createAsyncActionTypesArray('SEND_QUESTION'),

  // ----- FLOWS -----
  ...createAsyncActionTypesArray('SEND_QUESTION_FLOW'),

  'RESET_STATUS',
);
